import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  FormFeedback,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { useFormik } from "formik"
import * as Yup from "yup"
import { MetaTags } from "react-meta-tags"
import Select from "react-select"
import CorrectionAction from "store/correction-resource/actions"
import { getProductCategoryList, getProductList } from "store/actions"
import SButton from "components/Common/Button"

export default function DetailCorrection() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const store = useSelector(state => state)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      categoryId: "",
      productId: "",
      item: "",
      format: "TEXT",
      answer: "",
      labels: [],
    },
    validationSchema: Yup.object({
      categoryId: Yup.number().required("商品カテゴリー 必須項目です。"),
      productId: Yup.number().required("商品名 必須項目です。"),
      item: Yup.string().required("項目 必須項目です。"),
      format: Yup.string().required("形式 必須項目です。"),
      answer: Yup.number().when("format", format => {
        if (format != "TEXT") {
          return Yup.number().min(2).max(6).required("回答 必須項目です。")
        }
      }),
      labels: Yup.array().when("format", format => {
        if (format != "TEXT") {
          return Yup.array().of(
            Yup.object({
              label: Yup.string().required("回答 必須項目です。"),
              sequence: Yup.number().required("回答 必須項目です。"),
            })
          )
        }
      }),
    }),
    onSubmit: values => {
      console.log(values)
      if (params.id === "add") {
        dispatch(CorrectionAction.postData(values, callbackPost))
      } else {
        dispatch(
          CorrectionAction.putData({ ...values, id: params.id }, callbackPut)
        )
      }
    },
  })

  const callbackPost = (isSuccess = true, errors) => {
    if (isSuccess) {
      history.push("/master/correction")
      validation.resetForm()
    } else {
      console.log(errors, "errors")
      validation.setErrors(errors)
    }
  }

  const callbackPut = (isSuccess = true, errors) => {
    if (isSuccess) {
      history.push("/master/correction")
      validation.resetForm()
    } else {
      console.log(errors, "errors")
      validation.setErrors(errors)
    }
  }

  const callbackGetDetail = data => {
    validation.setValues(data)
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(CorrectionAction.getDetail({ id: params.id }, callbackGetDetail))
    }
  }, [params.id])

  React.useEffect(() => {
    dispatch(getProductCategoryList())
  }, [])

  return (
    <>
      <MetaTags>
        <title>補正マスター | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content" style={{ height: "850px" }}>
        <Container fluid>
          <Breadcrumbs title={"補正マスター"} breadcrumbList={[]} />

          <Card className="pb-5">
            <CardBody>
              {store.correction.detail.loading ? (
                <LoadingComponent />
              ) : (
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col md={8}>
                      <p className="fw-bold">
                        {params.id != "add"
                          ? "補正マスター詳細"
                          : "新規補正マスター追加"}
                      </p>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <SButton type="submit" className="me-2 button">
                        保存
                      </SButton>
                      <SButton
                        type="button"
                        className="ms-2 button"
                        onClick={() => history.push("/master/correction")}
                      >
                        キャンセル
                      </SButton>
                    </Col>
                  </Row>
                  <FormGroup row>
                    <Label sm="2">商品カテゴリー</Label>
                    <Col sm="6">
                      <Select
                        isLoading={!store.productCategory.list.length}
                        options={store.productCategory.list.map(i => ({
                          value: i.id,
                          label: i.name,
                        }))}
                        defaultValue={{
                          value: validation.values.categoryId,
                          label: validation.values.categoryName,
                        }}
                        value={{
                          value: validation.values.categoryId,
                          label: validation.values.categoryName,
                        }}
                        onChange={e => {
                          validation.setFieldValue("categoryName", e.label)
                          validation.setFieldValue("categoryId", e.value)
                          dispatch(getProductList({ categoryId: e.value }))
                        }}
                        isDisabled={params.id != "add"}
                      />
                      <Input
                        name="categoryId"
                        className="form-control d-none"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.categoryId || ""}
                        invalid={
                          validation.touched.categoryId &&
                          validation.errors.categoryId
                            ? true
                            : false
                        }
                      />
                      {validation.touched.categoryId &&
                      validation.errors.categoryId ? (
                        <FormFeedback type="invalid">
                          {validation.errors.categoryId}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm="2">商品名</Label>
                    <Col sm="6">
                      <Select
                        isLoading={!store.products.list.length}
                        options={store.products.list.map(i => ({
                          value: i.id,
                          label: i.productName,
                        }))}
                        defaultValue={{
                          value: validation.values.productId,
                          label: validation.values.productName,
                        }}
                        value={{
                          value: validation.values.productId,
                          label: validation.values.productName,
                        }}
                        onChange={e => {
                          validation.setFieldValue("productId", e.value)
                          validation.setFieldValue("productName", e.label)
                        }}
                        isDisabled={
                          params.id != "add" ||
                          validation.values.categoryId === ""
                        }
                      />
                      <Input
                        name="productId"
                        className="form-control d-none"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.productId || ""}
                        invalid={
                          validation.touched.productId &&
                          validation.errors.productId
                            ? true
                            : false
                        }
                      />
                      {validation.touched.productId &&
                      validation.errors.productId ? (
                        <FormFeedback type="invalid">
                          {validation.errors.productId}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </FormGroup>

                  <FormGroup row>
                    <Label sm="2">項目</Label>
                    <Col sm="6">
                      <Input
                        name="item"
                        className="form-control"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.item || ""}
                        invalid={
                          validation.touched.item && validation.errors.item
                            ? true
                            : false
                        }
                      />
                      {validation.touched.item && validation.errors.item ? (
                        <FormFeedback type="invalid">
                          {validation.errors.item}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label sm="2">形式</Label>
                    <Col sm="6">
                      <Select
                        options={[
                          "ラジオボタン",
                          "プルダウン",
                          "チェックボックス",
                          "TEXT",
                        ].map(i => ({ value: i, label: i }))}
                        defaultValue={{
                          value: validation.values.format,
                          label: validation.values.format,
                        }}
                        value={{
                          value: validation.values.format,
                          label: validation.values.format,
                        }}
                        onChange={e => {
                          validation.setFieldValue("format", e.value)
                        }}
                        isDisabled={params.id != "add"}
                      />
                      <Input
                        name="format"
                        className="form-control d-none"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.format || ""}
                        invalid={
                          validation.touched.format && validation.errors.format
                            ? true
                            : false
                        }
                      />
                      {validation.touched.format && validation.errors.format ? (
                        <FormFeedback type="invalid">
                          {validation.errors.format}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </FormGroup>

                  {validation.values.format != "TEXT" && (
                    <>
                      <FormGroup row>
                        <Label sm="2">回答</Label>
                        <Col sm="6">
                          <Select
                            options={[2, 3, 4, 5, 6].map(i => ({
                              value: i,
                              label: i,
                            }))}
                            defaultValue={{
                              value: validation.values.answer,
                              label: validation.values.answer,
                            }}
                            value={{
                              value: validation.values.answer,
                              label: validation.values.answer,
                            }}
                            onChange={e => {
                              validation.setFieldValue("answer", e.value)
                              const labels = []
                              for (let i = 0; i < e.value; i++) {
                                labels.push({
                                  label: "",
                                  sequence: i + 1,
                                })
                              }
                              validation.setFieldValue("labels", labels)
                            }}
                            isDisabled={params.id != "add"}
                          />
                          <Input
                            name="answer"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.answer || ""}
                            invalid={
                              validation.touched.answer &&
                              validation.errors.answer
                                ? true
                                : false
                            }
                          />
                          {validation.touched.answer &&
                          validation.errors.answer ? (
                            <FormFeedback type="invalid">
                              {validation.errors.answer}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <Row>
                        <Col sm={2}></Col>
                        <Col sm={6}>
                          <Row>
                            {validation.values.labels.map((i, k) => (
                              <React.Fragment key={k}>
                                <Col lg="3">
                                  <FormGroup row>
                                    <Col>
                                      <Input
                                        name={`labels.${k}.label`}
                                        className="form-control"
                                        placeholder=""
                                        type="text"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={i.label || ""}
                                        disabled={params.id != "add"}
                                        invalid={
                                          validation.touched?.labels &&
                                          validation.errors?.labels
                                            ? validation.touched?.labels[k]
                                                ?.label &&
                                              validation.errors?.labels[k]
                                                ?.label
                                              ? true
                                              : false
                                            : false
                                        }
                                      />
                                      {validation.touched.labels &&
                                      validation.errors.labels ? (
                                        <FormFeedback type="invalid">
                                          {
                                            validation.errors.labels[k]
                                              ?.sequence
                                          }
                                        </FormFeedback>
                                      ) : null}
                                    </Col>
                                  </FormGroup>
                                </Col>
                              </React.Fragment>
                            ))}
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}
                </Form>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
